import { BaseApi } from "../base";

/* eslint-disable camelcase */

export interface IUploadFinishPayload {
  s3Image: string;
  crop_coordinates: ICropCoordinates;
}

interface ICropCoordinates {
  top_left: ICoordinates;
  bottom_right: ICoordinates;
}

// @bug: https://livechatinc.atlassian.net/browse/API-2773
// Change to number after ticket is resolved
interface ICoordinates {
  x: string;
  y: string;
}

/* eslint-enable camelcase */

interface IUploadResponse {
  result: {
    path: string;
  };
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
}

export default class PreviewApi extends BaseApi {
  protected readonly prefix = "previews";

  previewUpload = (payload: FormData): Promise<IUploadResponse> => this.post("avatarPreview", payload);
  finishUpload = (payload: IUploadFinishPayload): Promise<IUploadResponse> => this.post("avatarPreview", payload);
}
